<template>
  <section class="lead-activity-card" v-bind:class="{ 'is-clickable': isClickable }">
    <div class="lead-activity-l ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key"> 
      <h3 class="address ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key">
        {{ leadActivity.lead.streetAddress }} {{ leadActivity.lead.suburb }}
      </h3>
      <div class="details ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key">
        {{ leadActivity.lead.firstName }} {{ leadActivity.lead.lastName }}
        <span class="ut-hidden md:ut-inline-block ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key">
          , {{ $helpers.convertFromUTC(leadActivity.lam.agentSendLeadDate, 'D MMM YYYY h:mm a') }}
        </span>
      </div>
      <div class=" md:ut-ml-8 ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key">
        <pill
          :happy="leadActivity.lam.leadAgentLeadStateId == 1"
          :danger="leadActivity.lam.leadAgentLeadStateId == 2"
          class="ut-mr-2 ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key">
          <span v-if="!statusFilter">{{ leadActivity.lam | leadStatus}}</span>
          <span v-if="statusFilter">{{ statusFilter }}</span>
        </pill>
        <pill class="ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key">{{ agentStageName }}</pill>
      </div>
    </div>
    <div class="lead-activity-r ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key">
      <avatar class="agent-avatar-sm md:ut-hidden ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key" :size="'sm'" :imgSrc="leadActivity.agent.imageUrl" />
      <avatar class="agent-avatar-md ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key" :imgSrc="leadActivity.agent.imageUrl">
        <div slot="name" class="ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key">{{ leadActivity.agent.displayName }}</div>
        <div slot="label" class="ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key">{{ agencyName }}</div>
      </avatar>

      <div class="contact-status ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key"
        v-bind:class="leadActivity.lam.leadAgentLeadStageId == 2 ||
        leadActivity.lam.leadAgentLeadStageId == 1 || requiresAttention ? 'not-attempted' : ''">

        <!-- If agent has not attepmted yet -->
        <p v-if="leadActivity.lam.leadAgentLeadStageId == 2 ||
                  leadActivity.lam.leadAgentLeadStageId == 1"
            class="ut-m-auto md:ut-ml-8 md:ut-w-1/2 ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key">Not attempted</p>

        <!-- If agent has attepeted and minutes are not null -->
        <p v-else-if="leadActivity.lam.attemptedAfterMinutes"
            class="ut-m-auto md:ut-ml-8 md:ut-w-1/2 ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key"
            :class="timeFlag(leadActivity.lam.attemptedAfterMinutes)">
            {{ formattedTemptedPosition }} · {{ leadActivity.lam.attemptedAfterMinutes |
            formatDuration }} to call</p>

        <!-- If minutes are null -->
        <p v-else class="ut-m-auto md:ut-ml-8 md:ut-w-1/2 ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key">Data unavailable</p>

        <p class="ut-m-auto md:ut-w-1/2 ga-event" data-eventlabel="Lead" :data-eventvalue="leadActivity.lead.key" data-eventvaluetype="Lead Key">{{ otherAgentsLeadStages }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import Avatar from '@/components/Avatar.vue';
import Pill from '@/components/Pill.vue';
import { LeadAgentLeadStageTypeId, LeadAgentLeadStageType } from '@/Mapper/LeadAgentLeadStageType';

export default {
  name: 'LeadActivityCard',
  components: {
    Avatar,
    Pill,
  },
  props: {
    leadActivity: {
      type: Object,
      required: true,
    },
    statusFilter: {
      required: true,
    },
    isClickable: {
      required: false,
      type: Boolean,
      default: false,
    },
    requiresAttention: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    agentStageName() {
      return LeadAgentLeadStageTypeId[this.leadActivity.lam.leadAgentLeadStageId];
    },
    agencyName() {
      if (this.leadActivity.agent
        && this.leadActivity.agent.agencyName
        && this.leadActivity.agent.agencyName.length > 0) {
        // Agency names are formatted "{{agency name}} - {{agency suburb}}"
        // We want to display only agency name
        return this.leadActivity.agent.agencyName.split(' - ').pop().trim();
      }
      return '';
    },
    otherAgentsLeadStages() {
      const agentsAttempted = this.leadActivity.otherLeadAgentMappings
        ? this.leadActivity.otherLeadAgentMappings.filter(lam => lam.leadAgentLeadStageTypeId === `${LeadAgentLeadStageType.Attempted}`)
        : [];
      const agentsContacted = this.leadActivity.otherLeadAgentMappings
        ? this.leadActivity.otherLeadAgentMappings.filter(lam => lam.leadAgentLeadStageTypeId === `${LeadAgentLeadStageType.Contacted_Vendor}`)
        : [];
      const agentsAppraised = this.leadActivity.otherLeadAgentMappings
        ? this.leadActivity.otherLeadAgentMappings.filter(lam => lam.leadAgentLeadStageTypeId === `${LeadAgentLeadStageType.Appraised}`)
        : [];
      const agentListed = this.leadActivity.otherLeadAgentMappings
        ? this.leadActivity.otherLeadAgentMappings.filter(lam => lam.leadAgentLeadStageTypeId === `${LeadAgentLeadStageType.Listed}`)
        : [];

      // If this agent has listed the property
      if (this.leadActivity.lam.leadAgentLeadStageId === `${LeadAgentLeadStageType.Listed}`) {
        return `${this.leadActivity.agent.displayName} listed`;
      }

      // Another agetn has listed the property
      if (agentListed.length > 0) {
        return 'Listed by another agent';
      }

      // Any agents Appraised
      if (agentsAppraised.length > 0) {
        return agentsAppraised.length === 1
          ? `${agentsAppraised.length} other agent appraised`
          : `${agentsAppraised.length} other agents appraised`;
      }

      // Any agents contacted
      if (agentsContacted.length > 0) {
        return agentsContacted.length === 1
          ? `${agentsContacted.length} other agent contacted`
          : `${agentsContacted.length} other agents contacted`;
      }

      // Has this agent contacted?
      if (this.leadActivity.lam.leadAgentLeadStageId === `${LeadAgentLeadStageType.Contacted_Vendor}`) {
        return `${this.leadActivity.agent.displayName} contacted`;
      }

      // Any agents Attempted
      if (agentsAttempted.length > 0) {
        return agentsAttempted.length === 1
          ? `${agentsAttempted.length} other agent attempted`
          : `${agentsAttempted.length} other agents attempted`;
      }

      // Has this agent attempted?
      if (this.leadActivity.lam.leadAgentLeadStageId === `${LeadAgentLeadStageType.Attempted}`) {
        return `${this.leadActivity.agent.displayName} attempted`;
      }

      return 'No other agent attempted';
    },
    formattedTemptedPosition() {
      switch (this.leadActivity.lam.attemptedPosition) {
        case 1:
          return '1st';
        case 2:
          return '2nd';
        default:
          return '3rd';
      }
    },
  },
  methods: {
    timeFlag(minoffset) {
      if (minoffset <= 60) {
        return 'green-flag';
      }

      if (minoffset > 120) {
        return 'red-flag';
      }

      return null;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .lead-activity-card {
    @apply ut-mb-3 ut-overflow-hidden ut-relative;
    box-shadow: 0 1px 2px 0 rgba(36,33,25,0.09), 0 2px 4px 0 rgba(36,33,25,0.17);
    border-radius: 5px;
    background-color: #FFFFFF;

    &.is-clickable {
      @apply ut-cursor-pointer;

      &:hover {
        @apply ut-shadow-md;
      }
    }

    @screen md {
      @apply ut-flex;
    }

    .address {
      @apply ut-mb-1;
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;

      @screen md {
        @apply ut-mb-0;
      }

      &:before {
        content: url('../assets/styles/frontend-library/images/pin.svg');
        @apply ut-align-middle ut-mr-2 ut-hidden;

        @screen md {
          @apply ut-inline-block;
        }

      }

    }

    .details {
      @apply ut-ml-0 ut-mb-6;
      font-size: 14px;
      line-height: 18px;

      @screen md {
        @apply ut-ml-8;
      }
    }

    .contact-status {
      @apply ut-flex ut-pt-2 ut-pb-3;
      border-top: 1px solid rgba(151, 151, 151, 0.2);

      p {
        font-size: 14px;
        line-height: 20px;
        color: #00393E;

        &::before {
          content: '';
            @apply ut-mr-1 ut-inline-block ut-bg-contain ut-bg-no-repeat;
            vertical-align: sub;
            height: 20px;
            width: 20px;
        }

        &:nth-child(1) {
          color: #00393E;
          &:before {
            background-image: url('../assets/styles/frontend-library/images/icon-phone.svg');
          }
        }

        &.green-flag {
          @apply ut-text-green-400;
          &:before {
            background-image: url('../assets/styles/frontend-library/images/phone-green.svg');
          }
        }

        &.red-flag {
          color: #DF6A52;
          &:before {
            background-image: url('../assets/styles/frontend-library/images/phone-red.svg');
          }
        }

        &:nth-child(2) {
          &:before {
              background-image: url('../assets/styles/frontend-library/images/user.svg');
              //@apply ut-inline-block
            }
        }

      }

      &.not-attempted {
        background-color: #DF6A52;

        p {
          color: #ffffff;

          &:nth-child(1) {
            &:before {
              background-image: url('../assets/styles/frontend-library/images/phone-white.svg');
            }
          }

          &:nth-child(2) {
            &:before {
              background-image: url('../assets/styles/frontend-library/images/user-white.svg');
            }
          }
        }
      }

    }

    .agent-avatar-sm {
      @apply ut-absolute ut-top-0 ut-right-0 ut-mt-3 ut-mr-4 ut-p-0;
    }

    .agent-avatar-md {
      @apply ut-py-6 ut-px-6;
      display: none !important;

      @screen md {
        display: flex !important;
      }
    }

    .lead-activity-l {
      @apply ut-py-4 ut-px-4 ut-w-full ut-my-0;
      border-right: 1px solid rgba(151, 151, 151, 0.2);

      @screen md {
        @apply ut-w-1/2 ut-px-6 ut-py-6;
      }
    }

    .lead-activity-r {
      @apply ut-w-full;

      @screen md {
        @apply ut-w-1/2;
      }
    }

  }

</style>
